module.exports = __webpack_public_path__ + "img/youtube.a381ee85.svg";